export function Step2Icon1() {
    return (
        <svg width="131" height="44" viewBox="0 0 131 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M84.763 1H72.7062C71.7639 1 71 1.74622 71 2.66667C71 7.26911 74.933 11 79.6445 11H95C95 5.47711 90.4168 1 84.763 1Z" stroke="#9B4DF6" strokeWidth="2" />
            <path
                d="M79.25 15.2572C77.3641 15.2572 75.5975 14.7824 74 14V15.2572C74 21.1903 78.701 26 84.5 26C90.299 26 95 21.1903 95 15.2572H79.25Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M116.484 1C112.987 1 109.912 2.64022 108 5.13656C108.44 5.61589 108.233 5.42978 108.521 5.80467C110.801 9.05822 114.618 11 118.73 11H127C127 5.47711 122.292 1 116.484 1Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M91.6722 27C89.6949 28.0829 87.4639 28.7543 85.0581 28.7543C82.6523 28.7543 80.4212 28.0829 78.4439 27C74.0996 29.3733 71 34.0611 71 39.3802V41.2485C71 42.2158 71.7803 43 72.7427 43H97.2573C98.2197 43 99 42.2158 99 41.2485V39.3802C99 34.0611 96.0165 29.3733 91.6722 27Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M122.556 27C120.579 28.0829 118.348 28.7543 115.942 28.7543C113.536 28.7543 111.305 28.0829 109.328 27C104.983 29.3733 102 34.0611 102 39.3802V41.2485C102 42.2158 102.78 43 103.743 43H128.257C129.22 43 130 42.2158 130 41.2485V39.3802C130 34.0611 126.9 29.3733 122.556 27Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M118.742 15.1929C113.862 15.1929 109.328 12.886 106.354 9C106.145 9.84363 106 10.7123 106 11.6222C106 12.353 106 25.1657 106 25.9999C107.653 24.7326 108.591 24.3622 109.862 23.621C110.652 23.9974 112.981 25.9049 116.5 25.9049C119.167 25.9049 120.95 24.8587 123.138 23.621C124.391 24.3517 125.348 24.7329 127 26V15.1929H118.742Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path d="M14.763 1H2.70616C1.76391 1 1 1.74622 1 2.66667C1 7.26911 4.93304 11 9.64455 11H25C25 5.47711 20.4168 1 14.763 1Z" stroke="#9B4DF6" strokeWidth="2" />
            <path
                d="M9.25 15.2572C7.36408 15.2572 5.59752 14.7824 4 14V15.2572C4 21.1903 8.70097 26 14.5 26C20.299 26 25 21.1903 25 15.2572H9.25Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M21.6722 27C19.6949 28.0829 17.4639 28.7543 15.0581 28.7543C12.6523 28.7543 10.4212 28.0829 8.44393 27C4.09963 29.3733 1 34.0611 1 39.3802V41.2485C1 42.2158 1.78028 43 2.74274 43H27.2573C28.2197 43 29 42.2158 29 41.2485V39.3802C29 34.0611 26.0165 29.3733 21.6722 27Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
        </svg>
    )
}
